import React, { useState } from "react";
import { useApi } from "../lib/useApi";

const manage_kickoff = (kickoff_string) => {
  const date = new Date(kickoff_string);
  const dateFormatter = new Intl.DateTimeFormat("en-ZA", {
    weekday: "long",
    day: "numeric",
    month: "long",
    hour: "2-digit",
    minute: "2-digit",
    timeZone: "Africa/Johannesburg",
    hour12: false,
  });
  const formattedDate = dateFormatter.format(date);
  return formattedDate.replace(",", "");
};

// A match stays listed until two hours after kickoff, so it is still there while in play:
// 90 minutes, half-time and stoppage time.
const LISTED_AFTER_KICKOFF_MS = 2 * 60 * 60 * 1000;
const stillListed = (now) => (item) => new Date(item.kickoff).getTime() + LISTED_AFTER_KICKOFF_MS > now;

const PreviewPage = () => {
  const [SortPreference, setSortPreference] = useState(0);

  const changeSortOrder = () => {
    if (SortPreference === 0) {
      setSortPreference(1);
    } else {
      setSortPreference(0);
    }
  };

  // The start-time order is taken from the alphabetical one, so previews with the same
  // kickoff stay in alphabetical order, as they did when the sorts ran one after the other.
  const { data: loaded_previews } = useApi(`/api/GetPreviews`, { select: (json) => json.value });
  const alphabetical = loaded_previews ? loaded_previews.filter(stillListed(Date.now())).sort((a, b) => a.RowKey.localeCompare(b.RowKey)) : [];
  const Previews = SortPreference === 0 ? alphabetical : [...alphabetical].sort((a, b) => a.kickoff.localeCompare(b.kickoff));

  return (
    <div className="row second">
      <div className="large-12 columns" style={{ paddingLeft: "0.3em" }}>
        {SortPreference === 0 ? (
          <>
            <h1>Match Previews - Alphabetical</h1>
            <p>
              <button
                onClick={changeSortOrder}
                style={{
                  background: "none",
                  border: "none",
                  padding: 0,
                  color: "grey",
                  cursor: "pointer",
                }}
              >
                Sort this page by kickoff
              </button>
              &nbsp; | &nbsp;
              <a
                href="https://www.soccer6.co.za/form-guides/previews-by-pool"
                style={{
                  color: "#001489",
                  fontWeight: "bold",
                }}
              >
                Match Previews By Pool
              </a>
            </p>
          </>
        ) : (
          <>
            <h1>Match Previews - by Start Date/Time</h1>
            <p>
              <button
                onClick={changeSortOrder}
                style={{
                  background: "none",
                  border: "none",
                  padding: 0,
                  color: "grey",
                  cursor: "pointer",
                }}
              >
                Sort this page alphabetically
              </button>
              &nbsp; | &nbsp;
              <a
                href="https://www.soccer6.co.za/form-guides/previews-by-pool"
                style={{
                  color: "#001489",
                }}
              >
                Match Previews By Pool
              </a>
            </p>
          </>
        )}
        {Previews.map((item) => (
          <p>
            <a href={"/h2h/" + item.PartitionKey} style={{ color: "#001489", fontWeight: "bold" }}>
              {item.RowKey}
            </a>
            <br />
            <span style={{ color: "grey", fontWeight: "bold" }}>{item.comp_name}</span>
            <br />
            <span style={{ color: "#001489", fontWeight: "bold" }}>{manage_kickoff(item.kickoff)}</span>
            <br />
            {item.preview} <br />
            <a href={"/h2h/" + item.PartitionKey} style={{ color: "#001489", fontSize: "0.8em", fontWeight: "bold" }}>
              View Head 2 Head Page
            </a>
            {item.full_preview ? (
              <>
                &nbsp; | &nbsp;
                <a href={"/FullPreview/" + item.full_preview} style={{ color: "#001489", fontSize: "0.8em", fontWeight: "bold" }}>
                  Read Full Preview
                </a>
              </>
            ) : null}
          </p>
        ))}
      </div>
    </div>
  );
};

export default PreviewPage;
